// import { $api } from '@shared/api';
// import { TFolderId } from '@widgets/Files/model/types/folderId.type';
//
// interface IDownloadObjectParams {
//     folderId: TFolderId | 'default';
// }
//
// export const downloadObject = async ({ folderId }: IDownloadObjectParams) => {
//     console.log('folderId', folderId);
//     // @ts-ignore
//     const downloadObjUrl = routable.getRoute('downloadObject').replace('_folder_', folderId);
//     console.log('downloadObjUrl: ', downloadObjUrl);
//     // if (folderId != null) {
//     //     getFilesUrl = `${getFilesUrl}/${folderId}`;
//     // }
//
//     try {
//         const res = await $api.get<Blob>(downloadObjUrl, {
//             responseType: 'blob',
//         });
//         console.log('download res: ', res);
//         const disposition = res.headers['content-disposition'] || '';
//         const filenameMatch = disposition.match(/filename="?(.+)"?/);
//         const filename = (filenameMatch && filenameMatch[1]) || `${folderId}.zip`;
//
//         return { blob: res.data, filename };
//     } catch (error: any) {
//         console.error('download object failed:', error);
//         return {
//             status: 'error',
//             data: null,
//             message: error.message,
//         };
//     }
// };

// import { $api } from '@shared/api';
// import { TFolderId } from '@widgets/Files/model/types/folderId.type';
//
// interface IDownloadObjectParams {
//     folderId: TFolderId | 'default';
// }
//
// export const downloadObject = async ({ folderId }: IDownloadObjectParams) => {
//     // @ts-ignore
//     const url = routable.getRoute('downloadObject').replace('_folder_', folderId);
//
//     const res = await $api.get(url, {
//         responseType: 'arraybuffer',
//         headers: { Accept: 'application/zip' },
//     });
//
//     const disposition = res.headers['content-disposition'] || '';
//
//     const zipNameMatch = disposition.match(/filename="?([^"]+?\.zip)"?/i);
//
//     let filename = zipNameMatch?.[1] || `${folderId}.zip`;
//
//     filename = filename.replace(/[\s_]+$/g, '');
//
//     const blob = new Blob([res.data], { type: 'application/zip' });
//
//     return { blob, filename };
// };

import { $api } from '@shared/api';
import { TFolderId } from '@widgets/Files/model/types/folderId.type';

interface IDownloadObjectParams {
    folderId: TFolderId | 'default';
}

function parseFilename(disposition: string, fallback: string): string {
    const rfc5987 = /filename\*\s*=\s*([^']*)''([^;]+)/i.exec(disposition);
    if (rfc5987) {
        try {
            return decodeURIComponent(rfc5987[2]).replace(/[\s_]+$/g, '');
        } catch {
            console.error('Unable to parse filename');
        }
    }

    const simple = /filename\s*=\s*"([^"]+)"/i.exec(disposition);
    if (simple) {
        let raw = simple[1];

        if (/[^\x00-\x7F]/.test(raw)) {
            const bytes = new Uint8Array(Array.from(raw).map((ch) => ch.charCodeAt(0) & 0xff));
            try {
                raw = new TextDecoder('utf-8').decode(bytes);
            } catch {
                raw = new TextDecoder('windows-1251').decode(bytes);
            }
        }

        return raw.replace(/[\s_]+$/g, '');
    }

    return fallback;
}

export const downloadObject = async ({ folderId }: IDownloadObjectParams) => {
    // @ts-ignore
    const url = routable.getRoute('downloadObject').replace('_folder_', folderId);
    const res = await $api.get(url, {
        responseType: 'arraybuffer',
        headers: { Accept: 'application/zip' },
    });

    const disposition = res.headers['content-disposition'] || '';
    const defaultName = `${folderId}.zip`;
    const filename = parseFilename(disposition, defaultName);

    const blob = new Blob([res.data], { type: 'application/zip' });
    return { blob, filename };
};
